module.exports = __webpack_public_path__ + "static/media/facebook-brands.8636de95.svg";